exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-packet-img[data-v-40e77686]{display:block;line-height:0px}.red-packet-img .upload-inner__box[data-v-40e77686]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.red-packet-img .red-packet-img-icon[data-v-40e77686]{margin-right:10px;border:1px dashed #d9d9d9;border-radius:6px;font-size:28px;color:#8c939d;width:78px;height:78px;line-height:78px;text-align:center}", ""]);

// exports
